const profileSectionConstants = {
  geoLocation: {
    es: 'Ubicación geográfica',
    pt: 'Localização geográfica',
  },
};

export default profileSectionConstants;
